module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.error
    }
  }, [(_vm.label) ? _c('label', {
    style: (_vm.styleLabel),
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    style: (_vm.styleSelect),
    attrs: {
      "name": _vm.name,
      "required": _vm.required
    },
    on: {
      "change": function($event) {
        return _vm.updateValue($event.target.value)
      }
    }
  }, [(_vm.placeholder) ? _c('option', {
    style: (_vm.styleOption),
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v(" \n        " + _vm._s(_vm.placeholder) + " \n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('option', {
      key: option.val,
      style: (_vm.styleOption),
      domProps: {
        "value": option.val,
        "selected": _vm.value == option.val
      }
    }, [_vm._v("\n        " + _vm._s(option.label) + "\n      ")])
  })], 2), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a06c2c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputSelect.vue
// module id = 280
// module chunks = 18